import { getQuoteOrRate } from '../utils/getQuoteOrRate';
export const getTradeRate = async (input, deps) => {
    const ratesResult = await getQuoteOrRate(input, deps);
    return ratesResult.map(rates => rates.map(rate => ({
        ...rate,
        quoteOrRate: 'rate',
        steps: rate.steps.map(step => step),
    })));
};
